export var ColorModel;
(function (ColorModel) {
    ColorModel[ColorModel["Depth"] = 0] = "Depth";
    ColorModel[ColorModel["Value"] = 1] = "Value";
    ColorModel[ColorModel["NumberOfChildren"] = 2] = "NumberOfChildren";
    ColorModel[ColorModel["OneEachChildren"] = 3] = "OneEachChildren";
})(ColorModel || (ColorModel = {}));
